import { render, staticRenderFns } from "./SapMemory.vue?vue&type=template&id=749e9e2c&"
import script from "./SapMemory.vue?vue&type=script&lang=js&"
export * from "./SapMemory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports